module.exports = __webpack_public_path__ + "img/验证配图.506ecf07.png";